<template>
	<div class="container">
		<div class="form_box footer_box">
			<div class="input_box">
				<div class="tit">First name</div>
				<input v-model="firstVal" :class="isClick && !firstVal ? 'error' : ''" />
				<div v-show="isClick && !firstVal" class="error_tit">Please complete this required field.</div>
			</div>
			<div class="input_box">
				<div class="tit">Last name</div>
				<input v-model="lastVal" :class="isClick && !lastVal ? 'error' : ''" />
				<div v-show="isClick && !lastVal" class="error_tit">Please complete this required field.</div>
			</div>
			<div class="input_box">
				<div class="tit" style="color: #0B318F;">Organization</div>
				<input v-model="organizationVal" :class="isClick && !organizationVal ? 'error' : ''" />
				<div v-show="isClick && !organizationVal" class="error_tit">Please complete this required field.</div>
			</div>
			<div class="input_box">
				<div class="tit" style="color: #0B318F;">Title</div>
				<input v-model="titleVal" :class="isClick && !titleVal ? 'error' : ''" />
				<div v-show="isClick && !titleVal" class="error_tit">Please complete this required field.</div>
			</div>
			<div class="input_box">
				<div class="tit">Email</div>
				<input v-model="emailVal" :class="isClick && !emailVal ? 'error' : ''" />
				<div v-show="isClick && !emailVal" class="error_tit">Please complete this required field.</div>
			</div>
			<div class="input_box">
				<div class="tit" style="color: #0B318F;">Phone Number</div>
				<input v-model="phoneVal" :class="isClick && !phoneVal ? 'error' : ''" />
				<div v-show="isClick && !phoneVal" class="error_tit">Please complete this required field.</div>
			</div>
			<div class="input_box">
				<div class="tit" style="color: #0B318F;">How can we help you today?</div>
				<textarea v-model="helpVal" :class="isClick && !helpVal ? 'error' : ''" style="height: 80px;line-height: 20px;"></textarea>
				<div v-show="isClick && !helpVal" class="error_tit">Please complete this required field.</div>
			</div>
			<div v-show="isClick && !lastVal && !firstVal && !organizationVal && !helpVal && !phoneVal && !emailVal && !titleVal" class="tips_box">
				<div class="error">Please complete all required fields.</div>
			</div>
			<div class="btn_box" @click="subClick">Submit</div>
		</div>
	</div>
</template>

<script>
import { formProductSubmit } from '@/api/public';
export default {
	components:{
		//
	},
	props: ['type'],
	data() {
		return {
			emailVal: '',
			firstVal: '',
			lastVal: '',
			organizationVal: '',
			titleVal: '',
			phoneVal: '',
			helpVal: '',
			isClick: false,
			productType: this.type,
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//点击提交
		subClick() {
			let that = this;
			that.isClick = true;
			if(that.emailVal && that.firstVal && that.lastVal && that.organizationVal && that.titleVal && that.phoneVal && that.helpVal) {
				that.$toast.loading({
					forbidClick: true,
				});
				let productName = 'Cordx Tyfast Flu A/B & COVID-19 Multiplex Rapid Test';
				if(that.productType == 2) {
					productName = 'CorDx Tyfast Flu A/B & COVID-19 At Home Multiplex Rapid Test';
				}
				formProductSubmit({
					product_name: productName,
					first_name: that.firstVal,
					last_name: that.lastVal,
					organization: that.organizationVal,
					title: that.titleVal,
					email: that.emailVal,
					phone_number: that.phoneVal,
					content: that.helpVal,
				}).then(res => {
					that.$toast.clear();
					that.$toast('Your form has been successfully submitted, thank you!');
					that.emailVal = '';
					that.firstVal = '';
					that.lastVal = '';
					that.organizationVal = '';
					that.titleVal = '';
					that.phoneVal = '';
					that.helpVal = '';
					that.isClick = false;
				});
			}
		},
	}
}
</script>

<style scoped>
.footer_box .input_box .tit::after{
	content: '*';
	color: #ff0000;
}
.footer_box .input_box .tit{
	color: #0B318F;
}
.footer_box .input_box input, .footer_box .input_box textarea, .footer_box .input_box select{
	width: 100%;
	background-color: #f5f8fa;
	color: #33475b;
	height: 42px;
	line-height: 21px;
	border: 1px solid #cbd6e2;
	padding: 10px;
}
.footer_box .input_box input.error{
	border-color: #c87872;
}
.footer_box .input_box textarea.error{
	border-color: #c87872;
}
.footer_box .input_box select.error{
	border-color: #c87872;
}
.footer_box .tips_box{
	margin-top: 8px;
}
.footer_box .tips_box .error{
	font-size: 14px;
	font-family: helvetica;
	color: #f2545b;
}
.footer_box .error_tit{
	color: #f2545b;
	font-size: 14px;
}
.footer_box .input_box_father{
	display: flex;
}
.footer_box .input_box{
	flex: 1;
	padding-bottom: 14px;
}
.footer_box .input_box_father .input_box:last-child{
	margin-left: 15px;
}
.footer_box .input_box_father .input_box:first-child{
	margin-right: 15px;
}
.footer_box .btn_box{
	display: inline-block;
	margin: 20px 0;
	padding: 14px 30px;
	text-align: center;
	background-color: #0B318F;
	cursor: pointer;
	color: #ffffff;
}
</style>
